/**
 * Async locale module loading
 * The webpack bundle-loader will generate chunks for each of the files in our i18n folder at compile time
 * When the locale is required, it will return a promise that the locale will be loaded
 *
 * @export
 * @param {string} locale
 * @returns {Promise<any>}
 */
export function LocaleLoader(locale) {
    return import(/* webpackChunkName: "i18n/[request]" */ "../../app/i18n/locales/" + locale);
}
